import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-perf-help-modal',
  templateUrl: './perf-help-modal.component.pug',
  styleUrls: ['./perf-help-modal.component.scss'],
  standalone: false
})
export class PerfHelpModalComponent implements OnInit {

  @Input() request;

  constructor(public _bsModalRef: BsModalRef) {
  }

  ngOnInit(): void {
  }

  close() {
    this._bsModalRef.hide();
  }

}
